import clsx from "clsx";
import React, { DetailedHTMLProps, FC, HTMLAttributes } from "react";

import { Icon, IconName } from "../../icon";

export interface PersonalAreaTabButtonProps
  extends Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "className"> {
  icon: IconName;
  active?: boolean;
  linkUrl?: string;
  label: string;
}

export const PersonalAreaTabButton: FC<PersonalAreaTabButtonProps> = ({
  icon,
  className,
  active = false,
  linkUrl,
  label,
  ...props
}) => (
  <a
    className={clsx(
      "rounded-3xl overflow-hidden flex flex-col gap-3 p-5 items-center",
      active ? "bg-primary" : "bg-neutral",
      className
    )}
    href={linkUrl}
    {...props}
  >
    <div className="bg-light overflow-hidden rounded-full flex justify-center items-center w-24 h-24">
      <Icon icon={icon} size={45} className="text-primary" />
    </div>

    <div
      className={clsx(
        "font-light text-lg leading-snug text-center truncate",
        active ? "text-light" : "text-primary"
      )}
    >
      {label}
    </div>
  </a>
);
